export function readCookie(name: string, source?: string | null): string | undefined {
  const raw =
    source ?? (typeof document !== 'undefined' ? document.cookie : undefined);
  if (!raw || typeof raw !== 'string') return undefined;
  const target = `${name}=`;
  const parts = raw.split(';');
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i] ?? '';
    const trimmed = part.trim();
    if (trimmed.indexOf(target) === 0) {
      const value = trimmed.slice(target.length);
      try {
        return decodeURIComponent(value);
      } catch {
        return value;
      }
    }
  }
  return undefined;
}
